export const INFORMATION_LIST = [
    {
        title: 'Lễ Vu Quy',
        time: 'Thứ 7, 3 tháng 12, 2022 11AM - 2AM',
        address: 'Nhà hàng tiệc cưới Quang Hương, Thôn 10, Xã Hòa Phú, BMT',
        phone: '083 247 5475',
        map: 'https://maps.app.goo.gl/8LR9D5ug47m8ucXGA?g_st=ic'
    },
    {
        title: 'Lễ Tân Hôn',
        time: 'CN, 4 tháng 12, 2022 11AM - 2AM',
        address: 'Nhà hàng tiệc cưới Thu Hương, Võ Văn Kiệt, P Khánh Xuân, BMT',
        phone: '083 247 5475',
        map: 'https://maps.app.goo.gl/tPUeqU9AUJkUZ9JJ8?g_st=ic'
    },
    {
        title: 'Lễ Báo Hỷ',
        time: 'Thứ 7, 17 tháng 12, 2022 18PM - 21PM',
        address: 'Nhà hàng tiệc cưới EMERALD, 139 Hoàng Diệu 2, Linh Trung, Thủ Đức, HCM',
        phone: '0969795353',
        map: 'https://goo.gl/maps/Gj586uxX9kDq7stu5'
    }
]
